import Modal from './Modal'
import { ModalHeader, ModalFooter, ModalScrollContent } from './styled'

export default Modal
export { Modal, ModalHeader, ModalFooter, ModalScrollContent }
